import { useState ,useEffect,useContext} from "react";
import { AppContext } from "../AppContext";
import { useParams } from "react-router-dom";
import "./design.css";
export default function Project() {
    const { data } = useContext(AppContext);
    const { projectId} = useParams();
 
  function scrollTop (){
    document.getElementById("app").scrollTo({
      top: 0,
      behavior: "smooth" // 平滑滚动
    }); 
  }
 
  useEffect(() => {

    
  }, []); // 空数组 => 只在首次挂载时执行（等价于 componentDidMount）

  return (
    <div id="pdesign">
      <div  className="pContent" >
            <img src={`/image/pdf${parseInt(projectId)}.jpg`} className="detail"/>
      </div>
      
      
      <section  onClick={()=>scrollTop()} id="toTop"><span >PAGE TOP</span></section>
    </div>
  );
}